import { FF_DISABLE_CONSULTATION_BUTTONS } from '@/constants/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { generateCalcomActionEmail } from '@/pages/consultations/utils';
import useUser from '@montugroup/circuit-shared/hooks/user/useUser';
import type { ButtonProps } from '@montugroup/design-system';
import type { PropsWithChildren } from 'react';
import CalendarPopupButton from './CalendarPopupButton';

export type BookConsultationButtonProps = PropsWithChildren<{
  buttonProps?: Omit<ButtonProps, 'children'>;
  disabled?: boolean;
  handleBookingSuccess?: () => void;
  handleRescheduleSuccess?: () => void;
  handleCancelSuccess?: () => void;
  calcomUrl?: string;
  onOpen?: () => void;
  testId?: string;
  togglePrimaryColours?: boolean;
}>;

const disabledButtonTooltip =
  'Bookings are temporarily disabled while we update our system. We appreciate your patience.';

export default function BookConsultationButton({
  buttonProps,
  disabled,
  handleBookingSuccess,
  handleRescheduleSuccess,
  handleCancelSuccess,
  calcomUrl,
  onOpen,
  testId,
  togglePrimaryColours = false,
  children,
}: BookConsultationButtonProps) {
  let calcomLink = calcomUrl;
  const { data: user } = useUser();

  const ffDisableConsultationButtons = useFeatureFlag(FF_DISABLE_CONSULTATION_BUTTONS);

  const prefillCalCom = {
    email: user?.email,
    name: `${user?.firstName} ${user?.lastName}`,
    phoneNumber: user?.phone,
  };

  if (!calcomLink) {
    return null;
  }

  if (user?.id) {
    calcomLink = `${calcomLink}?${generateCalcomActionEmail(user.id)}`;
  }

  return (
    <CalendarPopupButton
      testId={testId}
      link={calcomLink}
      formData={prefillCalCom}
      onOpen={() => {
        if (onOpen) {
          onOpen();
        }
      }}
      disabled={ffDisableConsultationButtons || disabled}
      buttonProps={buttonProps}
      tooltipProps={{ title: disabledButtonTooltip }}
      handleBookingSuccess={handleBookingSuccess}
      handleRescheduleSuccess={handleRescheduleSuccess}
      handleCancelSuccess={handleCancelSuccess}
      togglePrimaryColours={togglePrimaryColours}
    >
      {children}
    </CalendarPopupButton>
  );
}
